(function () {
  'use strict';

  var minimum = 10;
  var noticeId = 'b2b-minimum-order-notice';
  var refreshTimer;

  function findCheckout() {
    var direct = Array.prototype.find.call(
    document.querySelectorAll('button[name="checkout"], input[name="checkout"]'),
    function (element) {
      var rect = element.getBoundingClientRect();
      var style = window.getComputedStyle(element);
      return rect.width > 0 && rect.height > 0 && style.display !== 'none' && style.visibility !== 'hidden';
    }
  );
    if (direct) return direct;
    return Array.prototype.find.call(
      document.querySelectorAll('button, input[type="submit"], a[href*="/checkout"]'),
      function (element) {
        var text = (element.textContent || element.value || element.getAttribute('aria-label') || '').trim();
        return /check\s*out|zur\s*kasse|checkout/i.test(text);
      }
    );
  }

  function placeNotice() {
    var notice = document.getElementById(noticeId);
  var notice = document.getElementById(noticeId);
  if (!notice) {
    notice = document.createElement('div');
    notice.id = noticeId;
    notice.setAttribute('role', 'status');
    notice.setAttribute('aria-live', 'polite');
    notice.innerHTML = '<strong>Mindestabnahme: 10 Artikel</strong><br><span data-b2b-detail></span>';
    notice.style.cssText = 'margin:14px 0 0; padding:14px 16px; border:1px solid #d9a441; background:#fff7df; color:#2b2b2b; font-size:14px; line-height:1.5;';
  }
    var checkout = findCheckout();
    if (notice && checkout && checkout.parentNode && checkout.nextElementSibling !== notice) {
      checkout.insertAdjacentElement('afterend', notice);
    }
    return notice;
  }

  function renderCount(count) {
    var notice = placeNotice();
    if (!notice) return;
    var detail = notice.querySelector('[data-b2b-detail]');
    var b2bCustomer = document.querySelector("a[href*='company_location_id=']");
    notice.style.display = b2bCustomer && count < minimum ? 'block' : 'none';
    if (detail) {
      detail.textContent = 'Ihre B2B-Bestellung muss insgesamt mindestens ' + minimum + ' Artikel enthalten. Aktuell befinden sich ' + count + ' Artikel im Warenkorb.';
    }
  }

  function refreshCount() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) { renderCount(Number(cart.item_count) || 0); })
      .catch(function () { placeNotice(); });
  }

  function scheduleRefresh() {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(refreshCount, 350);
  }

  if (!window.__b2bMinimumNoticeInitialized) {
    window.__b2bMinimumNoticeInitialized = true;

    document.addEventListener('change', function (event) {
      if (event.target && event.target.matches('input[name^="updates"], select[name^="updates"], input[id^="qty-"], input[type="number"]')) {
        scheduleRefresh();
      }
    }, true);

    document.addEventListener('click', function (event) {
      var control = event.target && event.target.closest ? event.target.closest('button, a') : null;
      if (control && control.closest('cart-items, .cart-item, .cart__items, .quantity, [data-quantity]')) {
        scheduleRefresh();
      }
    }, true);

    document.addEventListener('cart:updated', scheduleRefresh);
    document.addEventListener('shopify:section:load', function () {
      window.setTimeout(refreshCount, 100);
    });

    new MutationObserver(function () { placeNotice(); }).observe(document.body, { childList: true, subtree: true });
  }

  placeNotice();
  refreshCount();
window.setTimeout(function () {
  placeNotice();
  refreshCount();
}, 600);
})();

(function () { var notice = document.getElementById('b2b-minimum-order-notice'); var title = notice && notice.querySelector('[data-b2b-title]'); if (title) title.textContent += ' (ASSET)'; })();

document.title += ' (ASSETTEST)';

// B2B tax note: Shopify can render the cart summary through a dynamic section.
// Replace the tax-inclusion wording only for customers in a company location.
(function () {
  const b2bOldTaxNote = /Steuern\s+inklusive\.\s+Der\s+Versand\s+wird\s+an\s+der\s+Kasse\s+berechnet/g;
  const b2bNewTaxNote = 'Die Mehrwertsteuer wird an der Kasse berechnet. Der Versand wird ebenfalls an der Kasse berechnet.';

  function isB2BCustomer() {
    return Boolean(document.querySelector('a[href*="company_location_id="]'));
  }

  function updateB2BTaxNote() {
    if (!document.body || !isB2BCustomer()) return;

    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    const textNodes = [];
    let node;

    while ((node = walker.nextNode())) {
      if (node.nodeValue && b2bOldTaxNote.test(node.nodeValue)) {
        textNodes.push(node);
      }
      b2bOldTaxNote.lastIndex = 0;
    }

    textNodes.forEach((textNode) => {
      textNode.nodeValue = textNode.nodeValue.replace(b2bOldTaxNote, b2bNewTaxNote);
      b2bOldTaxNote.lastIndex = 0;
    });
  }

  let updateQueued = false;
  function scheduleB2BTaxNoteUpdate() {
    if (updateQueued) return;
    updateQueued = true;
    const run = () => {
      updateQueued = false;
      updateB2BTaxNote();
    };
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(run);
    } else {
      window.setTimeout(run, 0);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleB2BTaxNoteUpdate, { once: true });
  } else {
    scheduleB2BTaxNoteUpdate();
  }

  new MutationObserver(scheduleB2BTaxNoteUpdate).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();



// B2B product quantity UX: AVADA's order-level rule can temporarily
// copy the order minimum into the product field. Keep the initial line
// quantity at 1; the order-level minimum remains enforced in the cart.
(function () {
  function isB2BCustomer() {
    return Boolean(
      document.querySelector('a[href*="company_location_id="]') ||
      (window.company_data && window.company_data.location_id)
    );
  }

  function resetInitialProductQuantity() {
    if (!isB2BCustomer()) return;

    var inputs = document.querySelectorAll(
      '#quantity, #product_qty_sticky, form[action*="/cart/add"] input[name="quantity"]'
    );

    Array.prototype.forEach.call(inputs, function (input) {
      if (!input || input.dataset.b2bInitialQuantityFixed === '1') return;

      // Only correct the AVADA-injected initial value. Do not overwrite
      // a quantity that the customer has already chosen.
      if (input.getAttribute('value') === '1' && Number(input.value) === 10) {
        input.value = '1';
        input.dataset.b2bInitialQuantityFixed = '1';
      }
    });
  }

  function scheduleInitialProductQuantityReset() {
    window.setTimeout(resetInitialProductQuantity, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleInitialProductQuantityReset, { once: true });
  } else {
    scheduleInitialProductQuantityReset();
  }

  document.addEventListener('shopify:section:load', scheduleInitialProductQuantityReset);
})();

// Remove legacy development markers from the document title.
document.title = document.title.replace(/\s+\((?:ASSET|ASSETTEST)\)/g, '');


// Keep the product-page line quantity at 1 while the order-level minimum
// of 10 remains enforced by AVADA in the cart and checkout.
(function () {
  var customerInteracted = false;
  var selector = '#quantity, #product_qty_sticky, form[action*="/cart/add"] input[name="quantity"]';

  function rememberCustomerInteraction(event) {
    var target = event.target;
    if (event.isTrusted && target && (target.matches(selector) || target.closest('form[action*="/cart/add"]'))) {
      customerInteracted = true;
    }
  }

  function resetInjectedMinimum() {
    if (customerInteracted || !document.querySelector('a[href*="company_location_id="]')) return;
    document.querySelectorAll(selector).forEach(function (input) {
      if (input.getAttribute('value') === '1' && Number(input.value) === 10) {
        input.value = '1';
      }
    });
  }

  document.addEventListener('click', rememberCustomerInteraction, true);
  document.addEventListener('input', rememberCustomerInteraction, true);
  document.addEventListener('change', rememberCustomerInteraction, true);

  var attempts = 0;
  var timer = window.setInterval(function () {
    resetInjectedMinimum();
    attempts += 1;
    if (attempts >= 80 || customerInteracted) window.clearInterval(timer);
  }, 100);
})();

// Remove legacy development markers from the document title.
document.title = document.title.replace(/\s+\((?:ASSET|ASSETTEST)\)/g, '');


// Keep the B2B warning below the visible desktop checkout button.
(function () {
  var noticeId = 'b2b-minimum-order-notice';
  var checkoutSelector = 'button[name="checkout"], button.cart__checkout-button, button[type="submit"][form*="cart-form"]';

  function getVisibleCheckout() {
    var buttons = document.querySelectorAll(checkoutSelector);
    return Array.prototype.find.call(buttons, function (button) {
      var rect = button.getBoundingClientRect();
      var style = window.getComputedStyle(button);
      return rect.width > 0 && rect.height > 0 && style.display !== 'none' && style.visibility !== 'hidden';
    });
  }

  function moveNoticeToVisibleCheckout() {
    var notice = document.getElementById(noticeId);
    var checkout = getVisibleCheckout();
    if (!notice || !checkout) return;

    if (notice.parentElement !== checkout.parentElement || notice.previousElementSibling !== checkout) {
      checkout.insertAdjacentElement('afterend', notice);
    }

    notice.style.display = 'block';
    notice.style.flex = '0 0 100%';
    notice.style.width = 'auto';
    notice.style.boxSizing = 'border-box';
    notice.style.order = '10';
  }

  function scheduleMove() {
    window.setTimeout(moveNoticeToVisibleCheckout, 0);
    window.setTimeout(moveNoticeToVisibleCheckout, 250);
    window.setTimeout(moveNoticeToVisibleCheckout, 800);
  window.setTimeout(moveNoticeToVisibleCheckout, 1500);
  window.setTimeout(moveNoticeToVisibleCheckout, 3000);
  window.setTimeout(moveNoticeToVisibleCheckout, 5000);
  }

  scheduleMove();
  document.addEventListener('cart:updated', scheduleMove);
  document.addEventListener('change', scheduleMove, true);
  document.addEventListener('click', scheduleMove, true);

  var cartRoot = document.querySelector('main') || document.body;
  if (cartRoot && window.MutationObserver) {
    new MutationObserver(scheduleMove).observe(cartRoot, { childList: true, subtree: true });
  }
})();


// Keep the B2B warning below the visible desktop checkout button.
(function () {
  var noticeId = 'b2b-minimum-order-notice';
  var checkoutSelector = 'button[name="checkout"], button.cart__checkout-button, button[type="submit"][form*="cart-form"]';
  function getVisibleCheckout() {
    var buttons = document.querySelectorAll(checkoutSelector);
    return Array.prototype.find.call(buttons, function (button) {
      var rect = button.getBoundingClientRect();
      var style = window.getComputedStyle(button);
      return rect.width > 0 && rect.height > 0 && style.display !== 'none' && style.visibility !== 'hidden';
    });
  }
  function moveNoticeToVisibleCheckout() {
    var notice = document.getElementById(noticeId);
    var checkout = getVisibleCheckout();
    if (!notice || !checkout) return;
    if (notice.parentElement !== checkout.parentElement || notice.previousElementSibling !== checkout) {
      checkout.insertAdjacentElement('afterend', notice);
    }
    notice.style.display = 'block';
    notice.style.flex = '0 0 100%';
    notice.style.width = 'auto';
    notice.style.boxSizing = 'border-box';
    notice.style.order = '10';
  }
  function scheduleMove() {
    window.setTimeout(moveNoticeToVisibleCheckout, 0);
    window.setTimeout(moveNoticeToVisibleCheckout, 250);
    window.setTimeout(moveNoticeToVisibleCheckout, 800);
  }
  scheduleMove();
  document.addEventListener('cart:updated', scheduleMove);
  document.addEventListener('change', scheduleMove, true);
  document.addEventListener('click', scheduleMove, true);
  var cartRoot = document.querySelector('main') || document.body;
  if (cartRoot && window.MutationObserver) {
    new MutationObserver(scheduleMove).observe(cartRoot, { childList: true, subtree: true });
  }
})();


// Final placement guard for async cart redraws.
(function () {
  var noticeId = 'b2b-minimum-order-notice';
  var selector = 'button[name="checkout"], button.cart__checkout-button, button[type="submit"][form*="cart-form"]';

  function fixPlacement() {
    var notice = document.getElementById(noticeId);
    if (!notice) return;
    var checkout = Array.prototype.find.call(document.querySelectorAll(selector), function (button) {
      var rect = button.getBoundingClientRect();
      var style = window.getComputedStyle(button);
      return rect.width > 0 && rect.height > 0 && style.display !== 'none' && style.visibility !== 'hidden';
    });
    if (!checkout) return;

    if (notice.parentElement !== checkout.parentElement || notice.previousElementSibling !== checkout) {
      checkout.insertAdjacentElement('afterend', notice);
    }
    notice.style.display = 'block';
    notice.style.flex = '0 0 100%';
    notice.style.width = 'auto';
    notice.style.boxSizing = 'border-box';
    notice.style.order = '10';
  }

  function guardPlacement() {
    var attempts = 0;
    var timer = window.setInterval(function () {
      fixPlacement();
      attempts += 1;
      if (attempts >= 60) window.clearInterval(timer);
    }, 250);
    fixPlacement();
  }

  guardPlacement();
  document.addEventListener('cart:updated', guardPlacement);
  document.addEventListener('change', guardPlacement, true);
  document.addEventListener('click', guardPlacement, true);
})();
